import { Form, useSearchParams } from "@remix-run/react";
import { useSubmit } from "@remix-run/react";
import { Pagination } from "./Pagination";
import { ReactNode } from "react";
import { FiltersPagination, Filters as TFilters } from "~/sanity/types-mapped";
import Grid from "../globals/Grid";
import * as styles from "./Filters.css";
import { Button } from "./Button";
// @ts-ignore
import Close from "@material-design-icons/svg/filled/close.svg?react";
import { Dropdown } from "./Dropdown";

export type FiltersProps = {
  items?: number;
  filters?: TFilters;
  pagination?: FiltersPagination;
  children?: ReactNode;
};

export const Filters = ({
  items = 0,
  filters,
  pagination,
  children,
}: FiltersProps) => {
  const [searchParams] = useSearchParams();
  const submit = useSubmit();

  const hasFilters = filters?.some((filter) => searchParams.has(filter.slug));

  return (
    <div>
      {filters && (
        <Grid>
          <div className={styles.filtersWrapper}>
            <Form
              name="filters"
              method="get"
              onReset={(event) => setTimeout(() => submit(event.currentTarget))}
            >
              <input type="hidden" name="page" />
              <div className={styles.filters}>
                {filters.map((filter: unknown, index: null | undefined) => {
                  return (
                    <Dropdown
                      key={index}
                      filter={filter}
                      searchParams={searchParams}
                      // submit={submit}
                    ></Dropdown>
                  );
                })}
                {hasFilters && (
                  <div>
                    <Button
                      size="sm"
                      type="reset"
                      theme="dark"
                      isPrimary={false}
                      icons={{ iconPrimary: <Close /> }}
                    >
                      Clear
                    </Button>
                  </div>
                )}
              </div>
            </Form>
          </div>
        </Grid>
      )}
      {children}
      {Boolean(!items) && <FiltersNoResults hasFilters={hasFilters} />}
      {pagination &&
        Boolean(items) &&
        typeof pagination.pageNumber === "number" &&
        pagination.totalPageCount > 1 && (
          <Grid>
            <div className={styles.pagination}>
              <Pagination pagination={pagination} anchorId="archive" />
            </div>
          </Grid>
        )}
    </div>
  );
};

export type FiltersNoResults = {
  hasFilters?: boolean;
};

export const FiltersNoResults = ({ hasFilters }: FiltersNoResults) => {
  return (
    <Grid className={styles.noResultsWrapper}>
      <div className={styles.filtersWrapper}>
        <Form name="filters" method="get" className={styles.noResults}>
          No Results
          {hasFilters && (
            // <button type="submit">Clear</button>
            <Button
              size="sm"
              type="submit"
              theme="dark"
              isPrimary={false}
              icons={{ iconPrimary: <Close /> }}
            >
              Clear
            </Button>
          )}
        </Form>
      </div>
    </Grid>
  );
};
